import { BaseAuth } from '@link/share/stores';
import { type UserCredential } from '@link/share/vendors/firebase';
import authApi from '@link/shop/services/endpoints/auth';

export class Auth extends BaseAuth {
  protected get authApi() {
    return authApi;
  }

  async exchangeToken(token: string, otp?: string, recaptchaToken?: string) {
    const res = await authApi.exchangeToken({
      body: {
        token,
        ...(otp ? { otp } : {}),
        ...(recaptchaToken ? { recaptchaToken } : {})
      }
    });
    if (res?.accessToken) this.setAccessToken(res.accessToken);
    if (res?.refreshToken) this.setRefreshToken(res.refreshToken);
    return res;
  }

  async updateToken(credential: UserCredential, recaptchaToken?: string) {
    const firebaseToken = await credential.user.getIdToken();
    await this.exchangeToken(firebaseToken, undefined, recaptchaToken);
  }
}

export default new Auth();
